import { DocumentEditModal } from "./Modal";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { EditDocumentModalOptions, DocumentEditModalProps } from "./types";
import { DocumentType } from "../../../types/DocumentType";

export function openDocumentEditModal(data: DocumentType, opts: EditDocumentModalOptions) : Promise<DocumentType> {
    return createConfirmation<DocumentEditModalProps, DocumentType>(confirmable(DocumentEditModal))({
        data,
        dialogId: `document_edit_modal_${data.documentId}`,
        ...opts
    });
}